var map = {
	"./alpfoodway_background10_resized.jpg": "pYJd",
	"./alpfoodway_background11_resized.jpg": "7VUD",
	"./alpfoodway_background12_resized.jpg": "RL8R",
	"./alpfoodway_background13_resized.jpg": "fizp",
	"./alpfoodway_background14_resized.jpg": "9v6C",
	"./alpfoodway_background15_resized.jpg": "iOrO",
	"./alpfoodway_background16_resized.jpg": "HBbu",
	"./alpfoodway_background17_resized.jpg": "Pl2d",
	"./alpfoodway_background18_resized.jpg": "Cl5c",
	"./alpfoodway_background1_resized.jpg": "k9ZN",
	"./alpfoodway_background2_resized.jpg": "omdU",
	"./alpfoodway_background3_resized.jpg": "shP3",
	"./alpfoodway_background4_resized.jpg": "Y88W",
	"./alpfoodway_background5_resized.jpg": "WWdp",
	"./alpfoodway_background6_resized.jpg": "O5be",
	"./alpfoodway_background7_resized.jpg": "6Nz6",
	"./alpfoodway_background8_resized.jpg": "VlXi",
	"./alpfoodway_background9_resized.jpg": "XWjL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Bbv1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpfoodway_images ^\.\/alpfoodway_background.*_resized\.jpg$
// module id = Bbv1
// module chunks = 1